
    import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/jmcp/node_modules/ui-core/utility/js/no-focusable-svg';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/jmcp/node_modules/ui-core/utility/js/observe-dom';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/jmcp/node_modules/ui-theme/js/utility/_sticky';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/jmcp/node_modules/ui-core/plugins/cookies/js/cookies';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/jmcp/node_modules/ui-core/basic/lists/js/list';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/jmcp/node_modules/ui-theme/js/components/_modal';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/jmcp/node_modules/ui-core/components/accordion/js/accordion';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/jmcp/node_modules/ui-theme/js/components/transplant';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/jmcp/node_modules/ui-core/components/drop-block/js/drop-block';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/jmcp/node_modules/ui-core/components/back-to-top/js/back-to-top';

import QuickSearch from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/jmcp/js/widgets/quick-search';
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/jmcp/node_modules/ui-core/widgets/ad-placeholder/js/ad-placeholder';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/jmcp/node_modules/ui-core/widgets/multi-search/js/multi-search';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/jmcp/node_modules/ui-core/widgets/raa/js/raa';

import ipRanges from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/jmcp/node_modules/ui-core/widgets/ip-ranges/js/ip-ranges';
import mobileMenuMain from './groups/_mobile-menu';
const main = (UX) => {
    const $list = Array.prototype.slice.call(document.getElementsByClassName('expandable-list')),
        $modal = Array.prototype.slice.call(document.getElementsByClassName('modal')),
        $accordion = Array.prototype.slice.call(document.getElementsByClassName('accordion')),
        $transplant = Array.prototype.slice.call(document.querySelectorAll('[data-toggle="transplant"]')),
        $dropBlock = Array.prototype.slice.call(document.querySelectorAll('[data-db-target-for]')),
        $backToTop = Array.prototype.slice.call(document.getElementsByClassName('back-to-top')),
        $quickSearch = Array.prototype.slice.call(document.getElementsByClassName('quick-search')),
        $adplaceholder = Array.prototype.slice.call(document.getElementsByClassName('js__toggleAdForm')),
        $multiSearch = Array.prototype.slice.call(document.getElementsByClassName('multi-search')),
        $ipRanges = document.querySelector('.ipRangesWidget')

try {
        UX.noFocusableSVG.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($list.length ) {
            UX.list.init($list);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($modal.length ) {
            UX.modal.init($modal);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($accordion.length ) {
            UX.accordion.init($accordion);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($transplant.length ) {
            UX.transplant.init($transplant);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($dropBlock.length ) {
            UX.dropBlock.init($dropBlock);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($backToTop.length ) {
            UX.backToTop.init($backToTop);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($quickSearch.length ) {
            UX.quickSearch = $quickSearch
                .map(item=>new QuickSearch(item).initialize())
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($adplaceholder.length ) {
            UX.adplaceholder.init($adplaceholder);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($multiSearch.length ) {
            UX.multiSearch.init($multiSearch);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($ipRanges ) {
            UX.ipRanges = new ipRanges($ipRanges).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
mobileMenuMain(UX);

}

    export default main;
        